export default "__VITE_ASSET__D04ImqOP__"